// extracted by mini-css-extract-plugin
export const privacymarkArea = "index-module--privacymark-area--KJCZb";
export const privacymarkImg = "index-module--privacymark-img--Cjxcp";